import store from '../store/index';

import ComposableState from '../models/store/composable-state.model';
import GenericStore from '../models/store/generic-store.model';

export const useStore = (): GenericStore => {
  return {
    state: store.state as ComposableState,
    getter: store.getters,
    commit: store.commit,
    dispatch: store.dispatch,
    store,
  };
};
